<template>
  <v-application v-if="access.item_discount">
    <v-layout row class="ma-2">
      <v-flex md8>
        <v-crud-card
          name="discount"
          v-bind:headers="headers"
          v-bind:data="discounts"
          v-bind:save="save_discount_form"
          v-bind:row="typing_discount"
          v-bind:remove="remove_discounts"
          v-bind:dialogCancel="dialogCancel"
          v-bind:num-pages="discounts_total"
          v-model="discounts_page"
          v-bind:numPages="numPages"
          v-bind:add_button_name="'add_discount'"
          ItemDiscount
          :data_loading="data_loading || loading_discount"
          @change-pagination="changePagination"
          v-bind:saveDisabled="saveDisabled"
        >
          <template #top>
            <v-layout>
              <v-spacer></v-spacer>
              <v-flex md6>
                <v-combobox
                  v-model="store"
                  label="Stores"
                  v-bind:items="stores"
                  item-text="name"
                  hide-details
                />
              </v-flex>
            </v-layout>
          </template>
          <v-form v-model="is_valid">
            <v-card-text>
              <v-text-field
                :label="$t('name')"
                :rules="[fieldRules.required]"
                ref="name"
                v-model="discount.name"
              />
              <v-radio-group row :label="$t('type')" v-model="discount.type">
                <v-radio :label="$t('percentage')" value="percentage"></v-radio>
                <v-radio :label="$t('amount')" value="sum"></v-radio>
              </v-radio-group>
              <!-- <v-text-field
                v-if="discount.type == 'percentage'"
                :label="$t('value')"
                :rules="[fieldRules.required]"
                type="number"
                ref="value"
                max="100"
                v-model="discount.value"
              />-->
              <vuetify-money
                v-if="discount.type == 'percentage'"
                v-model="discount.value"
                ref="value"
                :rules="[fieldRules.required, fieldRules.percent]"
                :label="$t('value')"
                v-bind:options="moneyOptionsPercent"
              />
              <vuetify-money
                v-else
                v-model="discount.value"
                ref="value"
                :rules="[fieldRules.required]"
                :label="$t('value')"
                v-bind:options="moneyOptionsAmount"
              />
            </v-card-text>
            <v-card-title class="title-2">{{ $t("stores") }}</v-card-title>
            <v-list class="mx-2">
              <v-list-item
                v-for="(service, index) in discount.services"
                v-bind:key="index"
              >
                <v-list-item-content>
                  <v-list-item-title>{{
                    service.service_name
                  }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch v-model="service.available" />
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-form>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Discounts from "../../mixins/items/discounts";
export default {
  name: "Discounts",
  mixins: [Discounts],
  data: () => ({
    headers: [
      { text: "Name", value: "name", align: "left" },
      { text: "Value", value: "value" },
    ],
    is_valid: false,
    moneyOptionsPercent: {},
    moneyOptionsAmount: {},
  }),
  methods: {
    changePagination(page) {
      this.discounts_page = page;
      this.update_discounts();
    },
    save_discount_form() {
      this.save_discount();
    },
    dialogCancel() {},
  },
  mounted() {
    this.headers = [
      { text: this.$t("name"), value: "name", align: "left", available: true },
      { text: this.$t("value"), value: "value" , available: true},
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.moneyOptionsPercent = {
      ...this.moneyOptions,
      prefix: "%",
      length: 3,
    };
    this.moneyOptionsAmount = {
      ...this.moneyOptions,
      length: 6,
    };
    // this.fieldRules.percent
  },
  computed: {
    form() {
      return {
        name: this.discount.name,
        value: this.discount.value,
      };
    },
    saveDisabled() {
      let formHasErrors = false || !this.is_valid;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) formHasErrors = true;
      });
      return formHasErrors;
    },
  },
  watch: {
    store: {
      deep: true,
      handler() {
        this.update_discounts();
      },
    },
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
